import { Button, Icon, Tooltip } from '@/ui';
import { useShowHiddenSourceEvents } from './useShowHiddenSourceEvents';

type Props = {
  /**
   * Whether the listed window holds any hidden occurrence — resolved during the
   * expansion, which is the only place that sees the set before the row cap.
   */
  hasHidden: boolean;
};

export const ShowHiddenToggle = ({ hasHidden }: Props) => {
  const { isShowingHidden, toggleShowHidden } = useShowHiddenSourceEvents();

  // Nothing to reveal — but while reveal mode is active the control has to stay
  // available so the user can always toggle back out.
  if (!hasHidden && !isShowingHidden) {
    return null;
  }

  const label = isShowingHidden ? 'Hide hidden events' : 'Show hidden events';

  return (
    <Tooltip label={label}>
      <Button
        aria-label={label}
        h="36px"
        minW="36px"
        px={0}
        variant="ahGhost"
        onClick={toggleShowHidden}
      >
        <Icon icon={isShowingHidden ? 'EyeOff' : 'Eye'} size={4} />
      </Button>
    </Tooltip>
  );
};
